import React from 'react';
import { projects } from '../data/projects';

import Project from './Project';

const Projects = () => {
    return (
        <section id='projects'>
            <h2 className='section-header'>Projects</h2>
            <div className='projects-container'>
                {projects.map(project => {
                    return <Project key={project.name} project={project} />
                })}
            </div>
        </section>
    )
}

export default Projects;